<template>
    <div class="navigationbar-box">
        <!-- 左边icons -->
        <div class="left">
            <el-image class="icon" :src="item.img.info.square" v-for="item, index in topLeftSourceList" :key="index" />
        </div>

        <div class="navigationbar">

            <!-- 标题栏 -->
            <div class="tabItem" v-for="(item, index) in bottomTab.navigationbar.tabs" :key="index"
                @click.stop="onItemClick($event, index)" :style="getSelectStyle(index)">
                {{ item.name }}
            </div>

        </div>

        <!-- 右边icons -->
        <div class="right" v-if="topRightSourceList && topRightSourceList.length > 0">
            <el-image class="icon" :src="item.img.info.square" v-for="item, index in topRightSourceList" :key="index" />
        </div>

        <!-- 分割线 -->
        <div class="divider" />

    </div>

</template>

<script>
import { GetMaterialGroupDetail } from '@/request/api'

export default {
    name: "NavigarionBarView",
    props: ['bottomTab'],
    data() {
        return {
            currentIndex: 0,
            topLeftSourceList: [],
            topRightSourceList: []
        }
    },
    methods: {
        onItemClick(event, index) {
            this.currentIndex = index
            this.$emit('onItemClick', index)
        },
        getSelectStyle(index) {
            if (index == this.currentIndex) {
                return 'color:' + this.bottomTab.navigationbar.color_select + ';'
                    + 'font-weight:bold;'
            } else {
                return 'color:' + this.bottomTab.navigationbar.color_default + ';'
                    + 'font-weight:normal;'
            }
        },
        /**
         * 获取素材组详情
         * @param {} type left/right
         */
        getMaterialGroupDetail(material_group_id, type) {
            if (!material_group_id) {
                if (type == 'left') {
                    // this.topLeftSourceList = []
                }
                else if (type == 'right') {
                    // this.topRightSourceList = []
                }
                return
            }
            GetMaterialGroupDetail(material_group_id)
                .then(data => {
                    console.log('getMaterialGroupDetail', data)
                    if (type == 'left') {
                        this.topLeftSourceList = data.list
                    }
                    else if (type == 'right') {
                        this.topRightSourceList = data.list
                    }
                    console.log('topLeftSourceList', this.topLeftSourceList.length)
                    console.log('topRightSourceList', this.topRightSourceList.length)
                })
        }
    },
    watch: {
        "bottomTab.top_left_source": {
            handler(newValue) {
                // this.getMaterialGroupDetail(newValue, 'left')
            }
        },
        "bottomTab.top_right_source": {
            handler(newValue) {
                // this.getMaterialGroupDetail(newValue, 'right')
            }
        }
    }
}
</script>

<style scoped lang="less">
.navigationbar-box {
    position: relative;
    width: 100%;
    display: flex;
    // background-color: #888;


    .left {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        margin-left: 5px;

        .icon {
            width: 25px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            margin-right: 5px;
        }
    }


    .right {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        margin-right: 5px;

        .icon {
            width: 25px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            margin-left: 5px;
        }
    }


    .navigationbar {
        height: 40px;
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: nowrap;
        position: relative;
        display: flex;

        .tabItem {
            width: 60px;
            display: inline-block;
            text-align: center;
            line-height: 40px;
        }
    }

}


.navigationbar::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    border-radius: 5px;
    background-color: #888;
}

.divider {
    width: 100%;
    height: 1.3px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #f5f5f5;
}
</style>